import { router } from 'expo-router';
import { useAuth } from '../../src/contexts/AuthContext';
import { OnboardingWizard } from '../../src/features/onboarding';

export default function OnboardingScreen() {
  const { currentOrganization } = useAuth();
  const organizationId = currentOrganization?.id ?? '';

  function handleComplete() {
    router.replace('/ai-agent');
  }

  return <OnboardingWizard organizationId={organizationId} onComplete={handleComplete} />;
}
